import { useEffect, useState, ChangeEvent, FocusEvent } from 'react';
import useAppState from '../../AppStore';

const radiansInDegrees = (radians: number) => radians * (180 / Math.PI);

const usePrintAngle = () => {
  const location = useAppState((state) => state.location);
  const setAngle = useAppState((state) => state.setAngle);

  const initialAngle = Math.trunc(radiansInDegrees(location.rotation ?? 0));
  const [inputAngle, setInputAngle] = useState(initialAngle.toString());

  useEffect(() => {
    const rotation = location.rotation ?? 0;
    let newAngle = radiansInDegrees(rotation) % 360;

    if (newAngle > 359) newAngle -= 360;
    if (newAngle < -359) newAngle += 360;

    const roundedAngle = Math.round(newAngle).toString();

    if (roundedAngle !== inputAngle) {
      setInputAngle(roundedAngle);
      setAngle(newAngle);
    }
  }, [location.rotation]);

  const handleAngleChanged = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value } = e.target;

    if (value === '' || value === '-') {
      setInputAngle(value);
      setAngle(Math.PI / 180);
      return;
    }

    const input = Number(value);
    if (!Number.isNaN(input) && input >= -359 && input <= 359) {
      setInputAngle(value);
      setAngle(input);
    } else {
      setInputAngle(inputAngle);
    }
  };

  const handleAngleFocus = (
    event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    if (event.target.value === '0') setInputAngle('');
  };

  const handleAngleBlur = (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.target.value === '') {
      setInputAngle('0');
      setAngle(Math.PI / 180);
    }
  };

  return { inputAngle, handleAngleChanged, handleAngleFocus, handleAngleBlur };
};

export default usePrintAngle;
